<template>
  <div class="doctor-patient-card">
    <loading-messages v-if="loading"></loading-messages>
    <template v-else-if="patient">
      <div class="row no-gutters align-items-center">
        <div class="col-auto mr-2">
          <div
            class="avatar"
            :style="{
              backgroundImage: `url(${staticUrl}${patient.photo})`
            }"
          ></div>
        </div>
        <div class="col">
          <h4>
            {{ patient.firstname[authLocale] }}
            {{ patient.lastname[authLocale] }}
          </h4>
          <ul class="list-group list-group-horizontal">
            <li class="p-2 list-group-item list-group-item-light" v-if="patient.birthdate">
              <small>
                {{ $moment().diff(patient.birthdate, "years") }}
                {{ $t("yearsOld") }}
              </small>
            </li>
            <li class="p-2 list-group-item list-group-item-light" v-if="patient.gender">
              <small>
                {{ $t(patient.gender) }}
              </small>
            </li>
            <li class="p-2 list-group-item list-group-item-light">
              <small>
                {{ $t(`${patient.personal_number}`) }}
              </small>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import LoadingMessages from '@/components/Loadings/Message'
export default {
  components: {
    LoadingMessages
  },
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      staticUrl: 'app/staticUrl'
    })
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError'
    })
  }
}
</script>
<style lang="scss">
.doctor-patient-card {
  .avatar {
    width: 100px;
    height: 100px;
  }
  ul {
    list-style: bullet;
    font-size: 0.9em;
  }
}
</style>
<i18n>
{
  "ka": {
      "yearsOld": "წლის",
      "male": "მამრ",
      "female": "მდედრ",
      "countryGE": "საქართველო",
      "languageka": "ქართული"
  }
}
</i18n>
